export const PreliminaryFeesSentValues = ["Yes", "No", "Not Applicable"] as const;
export type PreliminaryFeesSent = typeof PreliminaryFeesSentValues[number];